import {Validator} from 'vee-validate';
import registrationService from '@/http/services/registrationService';

const dictionary = {
    en: {
        messages: {
            required: () => 'This field is required',
            email: () => 'This field should be a valid email',
            confirmed: () => '“New Password” and “Confirm Password” doesn’t match',
            numeric: () => 'May contain numbers only',
            max: (name, args) => `Length should be less than ${args}`,
            min: (name, args) => `This field must be at least ${args} characters`,
            credit_card: () => 'You should provide the valid card number'
        }
    }
};

const latinValidator = {
    getMessage() {
        return 'May contain latin letters only';
    },
    validate(value) {
        return /^[a-zA-Z]+/.test(value);
    }
};

const passwordValidator = {
    getMessage() {
        return 'Password requires combination of 8 mixed case letters and numbers.';
    },
    validate(value) {
        return /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\S+$).*$/.test(value);
    }
};

const phoneValidator = {
    getMessage() {
        return 'You should fill the mask';
    },
    validate(value) {
        return /^[0-9]{3}[ ]{2}[0-9]{3}[ ]{2}[0-9]{4}/.test(value);
    }
};

const phoneValidatorForEngland = {
    getMessage() {
        return 'You should fill the mask';
    },
    validate(value) {
        return /^[0-9]{4}[ ]{2}[0-9]{3}[ ]{2}[0-9]{4}/.test(value);
    }
};

const addressValidator = {
    getMessage() {
        return 'May contain latin letters, numbers, white spaces, #, comma, dot and \'/\' only';
    },
    validate(value) {
        return /^[a-zA-Z0-9 #,./]+$/.test(value);
    }
};

const inputValidator = {
    getMessage() {
        return 'May contain latin letters, whitespaces and hyphens only';
    },
    validate(value) {
        return /^[a-zA-Z '\-]+$/.test(value);
    }
};

const customFormsValidator = {
    getMessage() {
        return 'The following symbols are not allowed: ^=+-*$^:/)(';
    },
    validate(value) {
        return /^[^=+\-*$^:/)()]+$/.test(value);
    }
};

const textareaValidator = {
    getMessage() {
        return 'May contain latin letters, numbers, whitespaces, hyphens, commas and points only';
    },
    validate(value) {
        return !/[^a-zA-Z0-9.,#`"\t`’﻿'!?:/@$()\\\ufeff -]+/.test(value);
    }
};

const uniqueEmailValidator = {
    getMessage() {
        return 'This email already exist';
    },
    async validate(value) {
        let validationResult;

        try {
            const result = await registrationService.checkUniqueEmail(value);
            validationResult = !result;
        } catch (e) {
            validationResult = true;
        }

        return validationResult;
    }
};

const passwordNotEqualEmailValidator = {
    getMessage() {
        return 'Your password cannot be similar to the email';
    },
    validate(value, args) {
        const password = value;
        const email = args[0];

        return password.toLowerCase() !== email.toLowerCase();
    }
};

Validator.extend('latin', latinValidator);
Validator.extend('password', passwordValidator);
Validator.extend('phone', phoneValidator);
Validator.extend('phone-uk', phoneValidatorForEngland);
Validator.extend('address', addressValidator);
Validator.extend('textarea', textareaValidator);
Validator.extend('customFormsValidator', customFormsValidator);
Validator.extend('input', inputValidator);
Validator.extend('uniqueEmail', uniqueEmailValidator);
Validator.extend('notEqualEmail', passwordNotEqualEmailValidator);

Validator.localize(dictionary);

export default Validator;


// WEBPACK FOOTER //
// ./src/utils/validator.js